@if (allowMultiple || control.controls.length === 0) {
  @if (dragAndDrop) {
    <div
      class="position-relative border rounded text-center px-2 py-4"
      [class.mb-3]="filePreviewMode === 'list'"
      wlDragAndDrop
      [accept]="allowedFileTypes"
      effect="copy"
      (fileDropped)="handleFileDragAndDrop($event)"
    >
      <input
        #fileDropRef
        type="file"
        [accept]="allowedFileTypes?.join(',')"
        [id]="control.id"
        class="position-absolute fixed-top w-100 h-100 invisible"
        [multiple]="allowMultiple"
        (change)="handleFileBrowser($event)"
        [wlAutomationId]="identifier + '-file-input'"
      />
      <fa-icon
        icon="arrow-to-top"
        size="lg"
        class="d-block mb-2 text-primary"
      ></fa-icon>
      <p *scText="dragAndDropInstructionsLabel" wlCSCapture></p>
      <label
        class="btn btn-outline-primary"
        role="button"
        wlCSCapture
        [for]="control.id"
        *scText="selectFileLabel"
      ></label>
    </div>
  }
  @if (!dragAndDrop) {
    <div>
      <input
        type="file"
        #fileEditRef
        [accept]="allowedFileTypes?.join(',')"
        [id]="control.id + '-edit'"
        class="position-absolute fixed-top w-100 h-100 invisible"
        [multiple]="allowMultiple"
        (change)="handleFileBrowser($event)"
        [wlAutomationId]="identifier + '-file-input'"
      />
      <label
        class="btn btn-primary mb-0 col-12 col-xl-auto"
        role="button"
        wlCSCapture
        [for]="control.id + '-edit'"
      >
        <fa-icon icon="arrow-to-top" class="px-1"></fa-icon>
        <span *scText="selectFileLabel"></span>
      </label>
    </div>
  }
}
@if (control.controls.length > 0) {
  @if (filePreviewMode === 'list') {
    <div [wlAutomationId]="identifier + '-file-input-file-list'" class="mb-3">
      <div class="border-bottom fw-bold pb-1" *scText="fileListHeading"></div>
      @for (
        fileControl of control.controls;
        track fileControl;
        let i = $index
      ) {
        <div
          class="align-items-center d-flex justify-content-between border-bottom"
          [wlAutomationId]="identifier + '-file-input-file-list-item'"
        >
          @if (files[fileControl.value]?.entry?.file; as file) {
            <fa-icon
              [icon]="fileControl.isValid ? 'file' : 'exclamation-triangle'"
              size="lg"
              class="px-1"
              [fixedWidth]="true"
              [class.text-primary]="fileControl.isValid"
              [class.text-danger]="fileControl.isInvalid"
            ></fa-icon>
            <div class="d-flex flex-column flex-grow-1 p-1 word-break">
              <span
                class="max-width"
                [wlAutomationId]="identifier + '-file-input-file-name'"
                [class.strike]="fileControl.errors?.file?.fileType"
              >
                {{ file.name }}
              </span>
              <span
                [wlAutomationId]="identifier + '-file-input-file-size'"
                class="text-body-secondary small"
                [class.strike]="fileControl.errors?.file?.maxSize"
              >
                {{ file.size | fileSize }}
              </span>
            </div>
            <button
              class="btn-close background-repeat"
              (click)="handleDeleteFile(i, file.name)"
              wlCSCapture
            ></button>
          }
        </div>
      }
    </div>
  } @else {
    <div [wlAutomationId]="identifier + '-file-input-file-picture'">
      @for (
        fileControl of control.controls;
        track fileControl;
        let i = $index
      ) {
        @if (files[fileControl.value]?.entry; as file) {
          <img
            class="mb-2 w-100 rounded"
            [alt]="'uploaded-image-' + identifier"
            [src]="getFilePath(file)"
          />

          <input
            type="file"
            #fileEditRef
            [accept]="allowedFileTypes?.join(',')"
            [id]="control.id + '-edit'"
            class="position-absolute fixed-top w-100 h-100 invisible"
            [multiple]="allowMultiple"
            (change)="handleFileBrowser($event)"
            [wlAutomationId]="identifier + '-file-input'"
          />
          <label
            class="btn btn-outline-primary mb-0 col-12 col-xl-auto"
            role="button"
            wlCSCapture
            [for]="control.id + '-edit'"
          >
            <fa-icon icon="pen-to-square" class="px-1"></fa-icon>
            <span *scText="changeFileLabel"></span>
          </label>
        }
      }
    </div>
  }
}
